import moment from 'moment';

export default (firstDateToMatch, secondDateToMatch = moment()) =>
  firstDateToMatch ? moment(firstDateToMatch).isSame(moment(secondDateToMatch), 'day') : false;
